import * as types from './mutation-types'

const mutations = {
  setLoginVisible (state, bool) {
    state.loginVisible = bool
  },
  reset (state) {
    state.userInfo = {}
    state.cartNum = 0
  },
  SET_USERINFO (state, userInfo) {
    state.userInfo = userInfo || {}
  },
  [types.SET_USERINFO] (state, obj) {
    state.userInfo = obj || {}
  },
  [types.SET_CARTNUM] (state, num) {
    state.cartNum = Number(num) || 0
  }
}

export default mutations
